import React, { useState } from "react";
import { parseTimeInput } from "../utils/helpers";

const TimeInput = ({
  onAddSession,
  disabled = false,
  placeholder = "Add time: 2h 30m",
}) => {
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");

  const handleAddTime = () => {
    if (!inputValue.trim()) {
      setError("Please enter a time value");
      return;
    }

    try {
      const totalSeconds = parseTimeInput(inputValue);
      if (totalSeconds <= 0) {
        setError("Time must be greater than 0");
        return;
      }

      const sessionData = {
        duration: totalSeconds,
        description: inputValue,
        type: "manual",
        createdAt: new Date().toISOString(),
      };

      onAddSession(sessionData);
      setInputValue("");
      setError("");
    } catch (err) {
      setError('Invalid time format. Use format like "2h 30m" or "90m"');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !disabled) {
      handleAddTime();
    }
  };

  return (
    <div className="time-input-container">
      <div className="time-input-row">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            setError("");
          }}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          className="time-input"
          disabled={disabled}
        />
        <button
          type="button"
          className="add-time-btn"
          onClick={handleAddTime}
          disabled={disabled || !inputValue.trim()}
        >
          ✓ Add Time
        </button>
      </div>

      {error && (
        <div className="time-error">
          <span className="error-message">{error}</span>
        </div>
      )}
    </div>
  );
};

export default TimeInput;
